import { useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'

import { getAllCampaignsCount, useMetadataQuery } from 'src/Redux/metadataApi'
import { getUserSelector } from 'src/Redux/auth-process/userSlice/selectors'
import { createCampaignStartEvent } from 'src/Helpers/TagManager'

export const useCreateCampaignStartEvent = (): void => {
  const user = useSelector(getUserSelector)
  const { data: campaigns } = useMetadataQuery(null)

  const amountOfCampaigns = getAllCampaignsCount(campaigns)
  const isEventSentRef = useRef(false)
  useEffect(() => {
    if (!user) {
      return
    }
    if (!isEventSentRef.current && amountOfCampaigns) {
      createCampaignStartEvent(user, amountOfCampaigns)
      isEventSentRef.current = true
    }
  }, [amountOfCampaigns, user])
}
